import '../../styles/inset-text.scss';

import { ReactNode } from 'react';

export interface InsetTextProps {
  className?: string;
  children?: ReactNode;
}

export default function InsetText({ className = '', children }: InsetTextProps) {
  return <div className={`govuk-inset-text ${className}`}>{children}</div>;
}
